import stripHtml from '../../utils/stripHtml'

/**
 * Zet notities om naar leesbare exportrijen.
 *
 * Werkt voor alle drie de soorten notities: bij een huishouden, bij een
 * deelnemer en bij een afspraak. De inhoud staat in `Body`; `Description` is
 * een restant uit oudere notities.
 *
 * @param {Array<object>} notes - Notitiedocumenten
 * @param {object} [options]
 * @param {(userId: string) => string} [options.getAuthor] - Vertaalt het gebruikers-ID naar een naam
 * @param {string} [options.subject] - Waar de notities bij horen, bijv. de naam van de deelnemer
 * @returns {Array<Record<string, any>>} Rijen voor de CSV
 */
const buildNotesExportRows = (notes, { getAuthor, subject } = {}) => {
    const formatDate = (value) => {
        if (!value) return ''
        const date = value?.toDate ? value.toDate() : new Date(value)
        if (Number.isNaN(date.getTime())) return ''
        return date.toISOString().slice(0, 10)
    }

    return (notes || []).map((note) => {
        const row = {
            Titel: note.Title || '',
            Datum: formatDate(note.Timestamp),
            Auteur: getAuthor ? getAuthor(note.UserID || note.User) || '' : (note.UserID || note.User || ''),
            Inhoud: stripHtml(note.Body || note.Description),
        }

        // Alleen een kolom toevoegen wanneer er iets in staat; anders krijgt
        // elke export een lege kolom die niemand nodig heeft.
        if (subject) return { Betreft: subject, ...row }
        return row
    })
}

export const NOTES_EXPORT_HEADER = ['Betreft', 'Titel', 'Datum', 'Auteur', 'Inhoud']

export default buildNotesExportRows
